import script from "./UnAuth.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnAuth.vue?vue&type=script&lang=ts&setup=true"

import "./UnAuth.vue?vue&type=style&index=0&id=23bdd2b2&lang=less"

const __exports__ = script;

export default __exports__